import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  CustomTagDto,
  CustomTagFullReferenceDto,
  CustomTagReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import CustomTagInline, { CustomTagInlineProps } from "./CustomTagInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: CustomTagDto | CustomTagFullReferenceDto | CustomTagReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<CustomTagInlineProps>;
}

export default function CustomTagLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.CustomTagRead]}
      to={ROUTE_PATH.CUSTOM_TAG_VIEW(entity?.id || entityId || "")}
      content={
        <CustomTagInline entity={entity} entityId={entityId} {...inlineProps} withTooltip={false} />
      }
      {...otherProps}
    />
  );
}
